(function () {
	Vue.component('nominow-input-text', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: { //this is intentionally left empty it could be string, boolean, null or even object...
				default: null
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			name: {
				type: String,
				required: false
			},
			required: {
				type: Boolean,
				required: false
			},
			regex: {
				type: String,
				required: false
			},
			regexMessage: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			narrow: {
				type: Boolean,
				required: false
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		template: `
        <div class="field" :class="{'mui-textfield' : (!nomui), 'is-narrow' : narrow}" >
        <input type="text" :class="css" :name="name || label" :value="value" @blur="$emit('change', $event.target.value)" @input="$emit('change', $event.target.value)" :data-val="(required || regex ? 'true' : null)" :data-val-required="required ? 'Required' : ''"  :data-val-regex="regexMessage" :data-val-regex-pattern="regex" />
        <label>{{label}}</label>
        </div>
        `
	});
})();

